import { Dropdown, IDropdownOption, Stack, Text } from '@fluentui/react'
import { ENVIRONMENTS, getEnvironment, setEnvironment } from '../../api/api'

const options: IDropdownOption[] = ENVIRONMENTS.map(e => ({ key: e.key, text: e.text }))

/**
 * Banner dropdown for selecting the data environment (production / staging).
 * Changing it persists the choice and reloads the app so every page refetches
 * from the newly selected backend databases.
 */
const EnvSelector = () => {
  const current = getEnvironment()

  const onChange = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    if (option && option.key !== current) {
      setEnvironment(option.key as string)
      window.location.reload()
    }
  }

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
      <Text styles={{ root: { color: '#fff', fontSize: 12, whiteSpace: 'nowrap' } }}>Environment</Text>
      <Dropdown
        ariaLabel="Data environment"
        selectedKey={current}
        options={options}
        onChange={onChange}
        styles={{
          root: { minWidth: 140 },
          title: {
            backgroundColor: 'rgba(255,255,255,0.12)',
            color: '#fff',
            borderColor: 'rgba(255,255,255,0.4)',
          },
          caretDown: { color: '#fff' },
        }}
      />
    </Stack>
  )
}

export default EnvSelector
